export default __webpack_public_path__ + "static/media/lunch-box.473b9635.png";